// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section.contact {
  background-color: #f8f8f8;
  perspective: 1000px;
}

.flipbook-section {
  opacity: 0;
  transform: rotateY(-15deg) translateZ(-100px);
  transform-style: preserve-3d;
  transition: all 1s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.flipbook-section.flipbook-visible {
  opacity: 1;
  transform: rotateY(0deg) translateZ(0);
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 4rem;
  max-width: 1200px;
  margin: 3rem auto 0;
  align-items: start;
}

.contact-intro h3 {
  font-size: 3rem;
  font-weight: 900;
  color: #000;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: -1px;
}

.contact-intro > p {
  font-size: 1.3rem;
  line-height: 1.8;
  color: #333;
  margin-bottom: 3rem;
  font-weight: 400;
}

.contact-methods {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.contact-method {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  padding: 1.5rem;
  background: #fff;
  border-radius: 12px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
}

.contact-method:hover {
  border-color: #ffbb00;
  box-shadow: 0 6px 20px rgba(255, 187, 0, 0.2);
  transform: translateX(5px);
}

.contact-method-icon {
  font-size: 2.5rem;
  flex-shrink: 0;
}

.contact-method-info h4 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #000;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.contact-method-info a {
  font-size: 1.1rem;
  color: #ffbb00;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.contact-method-info a:hover {
  color: #cc9900;
  text-decoration: underline;
}

.contact-form-wrapper {
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  border-radius: 16px;
  padding: 2.5rem;
  border: 3px solid #ffbb00;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  position: relative;
}

.contact-form-logo {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 2px solid #ffbb00;
}

.contact-form-logo img {
  height: 60px;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.1));
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-size: 1rem;
  font-weight: 700;
  color: #000;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-group input,
.form-group textarea {
  padding: 14px 18px;
  font-size: 1rem;
  border: 3px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  color: #000;
  font-weight: 500;
  transition: all 0.3s ease;
  font-family: inherit;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #ffbb00;
  box-shadow: 0 0 0 4px rgba(255, 187, 0, 0.2);
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

.contact-form .btn {
  margin-top: 0.5rem;
  font-size: 1.2rem;
  padding: 16px 40px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.contact-form .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.recaptcha-container {
  display: flex;
  justify-content: center;
  margin: 1.5rem 0;
}

.recaptcha-container > div {
  margin: 0 auto;
}

/* Success Message */
.contact-success-message {
  text-align: center;
  padding: 3rem 2rem;
  background: linear-gradient(135deg, rgba(255, 187, 0, 0.1) 0%, rgba(255, 187, 0, 0.05) 100%);
  border-radius: 12px;
  border: 2px solid #ffbb00;
}

.contact-success-message .success-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  font-weight: 900;
  margin: 0 auto 1.5rem;
  box-shadow: 0 4px 15px rgba(255, 187, 0, 0.3);
}

.contact-success-message h3 {
  font-size: 2rem;
  font-weight: 900;
  color: #000;
  margin: 0 0 1rem 0;
}

.contact-success-message p {
  font-size: 1.2rem;
  color: #333;
  margin: 0 0 2rem 0;
  line-height: 1.6;
}

.contact-success-message .btn {
  margin-top: 0;
}

/* Error Message */
.contact-error-message {
  padding: 1rem 1.25rem;
  background: #fee;
  border: 2px solid #fcc;
  border-radius: 8px;
  color: #c00;
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 1rem;
  text-align: center;
}

@media (max-width: 992px) {
  .contact-content {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .contact-intro h3 {
    font-size: 2.5rem;
  }

  .contact-intro > p {
    font-size: 1.1rem;
  }
}

@media (max-width: 768px) {
  .contact-content {
    gap: 2.5rem;
  }

  .contact-intro h3 {
    font-size: 2rem;
  }

  .contact-intro > p {
    font-size: 1rem;
    margin-bottom: 2rem;
  }

  .contact-method {
    padding: 1.25rem;
  }

  .contact-method-icon {
    font-size: 2rem;
  }

  .contact-method-info h4 {
    font-size: 1.1rem;
  }

  .contact-method-info a {
    font-size: 1rem;
  }

  .contact-form-wrapper {
    padding: 2rem 1.5rem;
  }

  .contact-form .btn {
    font-size: 1.1rem;
    padding: 14px 35px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Contact.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,6CAA6C;EAC7C,4BAA4B;EAC5B,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4FAA4F;EAC5F,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":["section.contact {\n  background-color: #f8f8f8;\n  perspective: 1000px;\n}\n\n.flipbook-section {\n  opacity: 0;\n  transform: rotateY(-15deg) translateZ(-100px);\n  transform-style: preserve-3d;\n  transition: all 1s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.flipbook-section.flipbook-visible {\n  opacity: 1;\n  transform: rotateY(0deg) translateZ(0);\n}\n\n.contact-content {\n  display: grid;\n  grid-template-columns: 1fr 1.2fr;\n  gap: 4rem;\n  max-width: 1200px;\n  margin: 3rem auto 0;\n  align-items: start;\n}\n\n.contact-intro h3 {\n  font-size: 3rem;\n  font-weight: 900;\n  color: #000;\n  margin-bottom: 1.5rem;\n  line-height: 1.2;\n  text-transform: uppercase;\n  letter-spacing: -1px;\n}\n\n.contact-intro > p {\n  font-size: 1.3rem;\n  line-height: 1.8;\n  color: #333;\n  margin-bottom: 3rem;\n  font-weight: 400;\n}\n\n.contact-methods {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.contact-method {\n  display: flex;\n  align-items: flex-start;\n  gap: 1.5rem;\n  padding: 1.5rem;\n  background: #fff;\n  border-radius: 12px;\n  border: 2px solid transparent;\n  transition: all 0.3s ease;\n}\n\n.contact-method:hover {\n  border-color: #ffbb00;\n  box-shadow: 0 6px 20px rgba(255, 187, 0, 0.2);\n  transform: translateX(5px);\n}\n\n.contact-method-icon {\n  font-size: 2.5rem;\n  flex-shrink: 0;\n}\n\n.contact-method-info h4 {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #000;\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.contact-method-info a {\n  font-size: 1.1rem;\n  color: #ffbb00;\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.3s ease;\n}\n\n.contact-method-info a:hover {\n  color: #cc9900;\n  text-decoration: underline;\n}\n\n.contact-form-wrapper {\n  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);\n  border-radius: 16px;\n  padding: 2.5rem;\n  border: 3px solid #ffbb00;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.contact-form-logo {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding-bottom: 2rem;\n  border-bottom: 2px solid #ffbb00;\n}\n\n.contact-form-logo img {\n  height: 60px;\n  width: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.1));\n}\n\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-group label {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #000;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.form-group input,\n.form-group textarea {\n  padding: 14px 18px;\n  font-size: 1rem;\n  border: 3px solid #e0e0e0;\n  border-radius: 8px;\n  background: #fff;\n  color: #000;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  font-family: inherit;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #ffbb00;\n  box-shadow: 0 0 0 4px rgba(255, 187, 0, 0.2);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.contact-form .btn {\n  margin-top: 0.5rem;\n  font-size: 1.2rem;\n  padding: 16px 40px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.contact-form .btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.recaptcha-container {\n  display: flex;\n  justify-content: center;\n  margin: 1.5rem 0;\n}\n\n.recaptcha-container > div {\n  margin: 0 auto;\n}\n\n/* Success Message */\n.contact-success-message {\n  text-align: center;\n  padding: 3rem 2rem;\n  background: linear-gradient(135deg, rgba(255, 187, 0, 0.1) 0%, rgba(255, 187, 0, 0.05) 100%);\n  border-radius: 12px;\n  border: 2px solid #ffbb00;\n}\n\n.contact-success-message .success-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #ffbb00 0%, #cc9900 100%);\n  color: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 3rem;\n  font-weight: 900;\n  margin: 0 auto 1.5rem;\n  box-shadow: 0 4px 15px rgba(255, 187, 0, 0.3);\n}\n\n.contact-success-message h3 {\n  font-size: 2rem;\n  font-weight: 900;\n  color: #000;\n  margin: 0 0 1rem 0;\n}\n\n.contact-success-message p {\n  font-size: 1.2rem;\n  color: #333;\n  margin: 0 0 2rem 0;\n  line-height: 1.6;\n}\n\n.contact-success-message .btn {\n  margin-top: 0;\n}\n\n/* Error Message */\n.contact-error-message {\n  padding: 1rem 1.25rem;\n  background: #fee;\n  border: 2px solid #fcc;\n  border-radius: 8px;\n  color: #c00;\n  font-size: 0.95rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n@media (max-width: 992px) {\n  .contact-content {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n  }\n\n  .contact-intro h3 {\n    font-size: 2.5rem;\n  }\n\n  .contact-intro > p {\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .contact-content {\n    gap: 2.5rem;\n  }\n\n  .contact-intro h3 {\n    font-size: 2rem;\n  }\n\n  .contact-intro > p {\n    font-size: 1rem;\n    margin-bottom: 2rem;\n  }\n\n  .contact-method {\n    padding: 1.25rem;\n  }\n\n  .contact-method-icon {\n    font-size: 2rem;\n  }\n\n  .contact-method-info h4 {\n    font-size: 1.1rem;\n  }\n\n  .contact-method-info a {\n    font-size: 1rem;\n  }\n\n  .contact-form-wrapper {\n    padding: 2rem 1.5rem;\n  }\n\n  .contact-form .btn {\n    font-size: 1.1rem;\n    padding: 14px 35px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
